import client from "./client";

function buildParams(base, filters) {
  const params = { ...base };
  if (filters?.grade) params.grade = filters.grade;
  if (filters?.class) params.class = filters.class;
  return params;
}

const dashboardApi = {
  getOverview(filters) {
    return client.get("/admin/dashboard/overview", { params: buildParams({}, filters) }).then((r) => r.data);
  },

  getAttendanceTrend(days = 14, filters) {
    return client.get("/admin/dashboard/attendance-trend", { params: buildParams({ days }, filters) }).then((r) => r.data);
  },

  getFeeCollection(filters) {
    return client.get("/admin/dashboard/fee-collection", { params: buildParams({}, filters) }).then((r) => r.data);
  },

  getClassPerformance(filters) {
    return client.get("/admin/dashboard/class-performance", { params: buildParams({}, filters) }).then((r) => r.data);
  },

  getTodayAbsentees(filters) {
    return client.get("/admin/dashboard/today-absentees", { params: buildParams({}, filters) }).then((r) => r.data);
  },

  getAlerts(limit = 50, filters) {
    return client.get("/admin/dashboard/alerts", { params: buildParams({ limit }, filters) }).then((r) => r.data);
  },

  getUpcomingDues(days = 7, filters) {
    return client.get("/admin/dashboard/upcoming-dues", { params: buildParams({ days }, filters) }).then((r) => r.data);
  },

  getLiveClasses() {
    return client.get("/admin/dashboard/live-classes").then((r) => r.data);
  },
};

export default dashboardApi;
